import Api from '.';

/**
 * Retrieve all professions.
 */
export function listProfessions() {
  return Api.get('/profession');
}

/**
 * Retrieve all professions of client.
 */
export function getClientProfessions(clientId) {
  return Api.get(`/profession/client/${clientId}`);
}

/**
 *
 * Lazy list Profession.
 */
export function lazyGetProfession({ search, page, perPage }) {
  return Api.get(`/profession/lazy?search=${search}&page=${page}&perPage=${perPage}`);
}

/**
 *
 * create a profession.
 */
export function createProfession(profession) {
  return Api.post('/profession', profession);
}

/**
 *
 * Update profession.
 */
export function updateProfession(id, profession) {
  return Api.put(`/profession/${id}`, profession);
}

/**
 *
 * Update profession status.
 */
export function reactivateProfessionStatus(id) {
  return Api.put(`/profession/${id}/activate`);
}

/**
 *
 * Update profession status.
 */
export function deactivateProfessionStatus(id) {
  return Api.put(`/profession/${id}/deactivate`);
}
